module.exports = __webpack_public_path__ + "img/pic_3_zh_new.14ce300d.png";